import { render } from "./Ozon.vue?vue&type=template&id=68d66b4d"
import script from "./Ozon.vue?vue&type=script&lang=js"
export * from "./Ozon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__